// File: src/utils/sessionHeader.js
// Adds the driver's session token to every call this app makes to its own
// Netlify functions.
//
// The functions check it (functions/session-auth.js): a request is only acted
// on for the driver whose email the token was issued to. Doing it here, once,
// rather than at each of the ~45 fetch calls means a new call can't forget it
// — a forgotten header would only show up when enforcement is switched on, as
// that call failing for every driver.
//
// Before the driver has verified their email there is no token, and nothing is
// added (sending the code and checking it don't need one).

const FUNCTIONS_PATH = '/.netlify/functions/';

function requestUrl(input) {
  if (typeof input === 'string') return input;
  if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
  if (input && typeof input.url === 'string') return input.url; // a Request
  return null;
}

function isOwnFunctionCall(input) {
  const url = requestUrl(input);
  if (!url) return false;
  if (url.startsWith(FUNCTIONS_PATH)) return true;
  try {
    const parsed = new URL(url, window.location.href);
    return parsed.origin === window.location.origin && parsed.pathname.startsWith(FUNCTIONS_PATH);
  } catch {
    return false;
  }
}

export function installSessionHeader() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  if (window.fetch.__oooshSessionHeader) return; // already installed

  const originalFetch = window.fetch.bind(window);

  const fetchWithSession = (input, init) => {
    try {
      if (isOwnFunctionCall(input)) {
        const token = window.sessionStorage.getItem('verificationSessionToken');
        if (token) {
          const baseHeaders = (init && init.headers) ||
            (typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined);
          const headers = new Headers(baseHeaders);
          if (!headers.has('X-Session-Token')) headers.set('X-Session-Token', token);
          init = { ...(init || {}), headers };
        }
      }
    } catch {
      // Never stop a request over this — send it as it was.
    }
    return originalFetch(input, init);
  };

  fetchWithSession.__oooshSessionHeader = true;
  window.fetch = fetchWithSession;
}
